import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styled from "styled-components";

interface SortableSectionProps {
  id: string;
  children: React.ReactNode;
  renderControls?: (props: {
    sectionId: string;
    listeners: SyntheticListenerMap | undefined;
  }) => React.ReactElement;
  onClick?: () => void;
}
export const SortableSection = ({
  id,
  children,
  renderControls,
  onClick,
}: SortableSectionProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={{ ...style }} {...attributes}>
      {renderControls?.({
        sectionId: id,
        listeners: listeners,
      })}
      <SortableSectionContainer
        {...listeners}
        onClick={() => {
          // Only trigger click if we haven't dragged
          if (!isDragging) {
            onClick?.();
          }
        }}
        style={{
          display: "block",
          height: "fit-content",
          width: "fit-content",
          padding: 0,
        }}
      >
        {children}
      </SortableSectionContainer>
    </div>
  );
};

const SortableSectionContainer = styled.div`
  display: block;
  height: fit-content;
  width: fit-content;
  padding: 0;
`;
